import Intercom from '@intercom/messenger-js-sdk';

import type { UserDetail } from 'src/api-sdk';
import { isAssistantEnabled } from 'src/components/Assistant/feature';

/**
 * Boot the Intercom messenger for the signed-in user. Users with the
 * assistant feature get the in-app assistant launcher instead, so they never
 * see two chat bubbles.
 */
export function bootIntercom(user: UserDetail | null | undefined): void {
  const appId = process.env.NEXT_PUBLIC_INTERCOM_APP_ID;
  if (!user || !appId || isAssistantEnabled(user)) return;
  Intercom({
    app_id: appId,
    region: 'eu',
    name: `${user.first_name} ${user.last_name}`,
    email: user.username,
    user_hash: user.intercom_user_hash,
    company: {
      id: user.active_profile?.external_id,
      name: user.active_profile?.name,
    },
  });
}
